import * as SX from './sx';
import * as Styled from './styles';

import { Box, Button, Stack, Typography } from '@mui/material';
import { MouseEventHandler, memo } from 'react';

import { ChangeDuration } from '../change-duration';
import { CurrentPlanAlert } from '../current-plan-alert';
import { Icon } from '@aibees/shared/components';
import { PricingCards } from '../pricing-cards';
import type { PricingHeaderProps as Props } from './types';
import { classnames } from '@aibees/shared/utils';
import { useNavigate } from 'react-router-dom';
import usePriceAndPlanStore from '@aibees/shared/features/price-and-plan/store';

export const PricingHeader = memo(({ className }: Props) => {
  const yearly = usePriceAndPlanStore((s) => s.yearly);
  const navigate = useNavigate();

  const handleBack: MouseEventHandler<HTMLButtonElement> = () => {
    navigate(-1);
  };

  return (
    <Styled.Wrapper
      className={classnames('PricingHeader', className)}
      sx={SX.root}
    >
      <Stack sx={SX.box}>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          gap={4}
        >
          <Stack
            justifyContent="space-between"
            alignItems="center"
            gap={1.25}
            width="100%"
          >
            <Typography variant="h3" fontWeight={700} color="grey.700">
              Plan & Pricing
            </Typography>
            <Typography variant="body3" fontWeight={400} color="grey.700">
              Flexible plans designed for teams of all sizes. Simple,
              transparent pricing to help you grow.{' '}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" width="100%">
            <Box sx={{ flex: 1, display: 'flex' }}>
              <Button
                size="small"
                variant="soft"
                startIcon={<Icon name="arrow-left-fill" size={16} />}
                onClick={handleBack}
              >
                Back
              </Button>
            </Box>
            <ChangeDuration />
            <Box sx={{ flex: 1 }} />
          </Stack>
        </Stack>
        <CurrentPlanAlert />
        <PricingCards yearly={yearly} />
      </Stack>
    </Styled.Wrapper>
  );
});

PricingHeader.displayName = 'PricingHeader';
